const NAV_ITEMS = [
    {
        anchor: '#overview-header-section',
        text: 'tocLinkOverview',
    },
    {
        anchor: '#faq-header-section',
        text: 'tocLinkFaqs',
    },
    {
        anchor: '#amenities-header-section',
        text: 'tocLinkAmenities',
    },
    {
        anchor: '#map-header-section',
        text: 'tocLinkMap',
    },
    {
        anchor: '#nearby-header-section',
        text: 'tocLinkNearby',
    },
    {
        anchor: '#carrier-section',
        text: 'tocLinkCarriers',
    },
    {
        anchor: '#routes-header-section',
        text: 'tocLinkRoutes',
    },
];

export {
    NAV_ITEMS,
};
